import { Component, computed, input, signal, Signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { EditingService, MeasurementType } from "@evident/ngx-media-viewer";
import { DropdownModule } from "primeng/dropdown";
import { TranslateTestingModule } from "../../../../../test/translate-testing.module";
import { toSignal } from "@angular/core/rxjs-interop";
import { SelectModule } from "primeng/select";
import { CommonModule } from "@angular/common";

@Component({
    selector: "app-measurement-picker",
    imports: [FormsModule, SelectModule, TranslateTestingModule, CommonModule],
    templateUrl: "./measurement-picker.component.html",
    styleUrl: "./measurement-picker.component.scss",
    standalone: true
})
export class MeasurementPickerComponent {
  public disabled = input(true);
  public readonly measurementTypes = Object.values(MeasurementType);
  public selectedMeasurement = computed(() => this.isEditing() ? this.selectedMeasurementType(): null);
  private readonly selectedMeasurementType: Signal<MeasurementType | null>;
  private readonly isEditing: Signal<boolean>;

  constructor(private editingService: EditingService) {
    this.selectedMeasurementType = toSignal(this.editingService.selectedMeasurementType$);
    this.isEditing = toSignal(this.editingService.isEditing$, { initialValue: false });
  }

  public async onMeasurementTypeChange(type: MeasurementType) {
    if (!type) return;

    if (this.editingService.selectedMeasurementType && this.editingService.temporaryMeasurement)
      await this.editingService.processMeasurement(this.editingService.temporaryMeasurement);

    if (this.selectedMeasurementType() === type) {
      this.editingService.selectedMeasurementType = null;
      this.editingService.disable();
      return;
    }

    this.editingService.selectedMeasurementType = type;
    this.editingService.enable();
  }
}
